import React from 'react';
import { Text } from '@beef/ui-kit';
import PropTypes from 'prop-types';
export var Value = function Value(_ref) {
  var value = _ref.value,
    unit = _ref.unit,
    icons = _ref.icons,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "cards-Values"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size1-m",
    tagType: "span"
  }, value), /*#__PURE__*/React.createElement("span", {
    className: "mar-l-2xs"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-m",
    tagType: "span"
  }, unit)), icons);
};
Value.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.node,
  unit: PropTypes.node,
  icons: PropTypes.node,
  className: PropTypes.string
} : {};